import { render, staticRenderFns } from "./LayoutElementTypeRelated.vue?vue&type=template&id=59281f5a"
import script from "./LayoutElementTypeRelated.vue?vue&type=script&lang=js"
export * from "./LayoutElementTypeRelated.vue?vue&type=script&lang=js"
import style0 from "./LayoutElementTypeRelated.vue?vue&type=style&index=0&id=59281f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports